import { render, staticRenderFns } from "./CandidateItemPipelineMobile.vue?vue&type=template&id=218dedde&scoped=true"
import script from "./CandidateItemPipelineMobile.vue?vue&type=script&lang=js"
export * from "./CandidateItemPipelineMobile.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemPipelineMobile.vue?vue&type=style&index=0&id=218dedde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218dedde",
  null
  
)

export default component.exports